import { Grid, Text, SVGIcon } from '@custom-components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withRouter } from 'next/router';
import { getRoutePath } from '@routes/routes.util';
import { withActiveLocale, withActiveLocalePropType } from '../../../hocs/withActiveLocale';

import { StyledHeaderCol, StyledBackIcon, TitleSection, TitleSpan } from './PageHeader.styles';
import NavLink from '../../FixedComponents/MainNav/common/NavLink';

/**
 * The DefaultLayout component wraps the content of pages with common elements such
 * as a global navigation and footer.
 */
class PageHeader extends Component {
  getPrevButton = () => {
    const { prevButton, activeLocale, router } = this.props;

    if (!prevButton.route) {
      return (
        <StyledBackIcon onClick={prevButton.onClick}>
          <SVGIcon selectedIcon="arrow" width="30px" height="30px" rotate={90} />
        </StyledBackIcon>
      );
    }

    const href = getRoutePath({ routeName: prevButton.route, locale: activeLocale.id, params: prevButton.params });

    const routerClick = (event) => {
      // Prevent a hard page reload when link is clicked
      event.preventDefault();

      // Route to the the page
      router.push(href).then(() => {
        window.scrollTo(0, 0);
        document.body.focus();

        // Closes menu after navigating to the new route
        if (typeof prevButton.onClick === 'function') {
          prevButton.onClick();
        }
      });
    };

    return (
      <NavLink href={href} onClick={routerClick}>
        <StyledBackIcon>
          <SVGIcon selectedIcon="arrow" width="30px" height="30px" rotate={90} />
        </StyledBackIcon>
      </NavLink>
    );
  };

  render() {
    const { pageName, subPageName, prevButton, otherButton } = this.props;

    return (
      <Grid.Container fluid={false}>
        <Grid.Row>
          <StyledHeaderCol md={12}>
            {prevButton && this.getPrevButton()}
            {pageName && (
              <TitleSection>
                <TitleSpan>
                  <Text.HeadingSecond align="left" tagName="div" textTransform="uppercase">
                    {pageName}
                  </Text.HeadingSecond>
                </TitleSpan>
                {subPageName && (
                  <TitleSpan>
                    <Text.HeadingFourth align="left" tagName="span" textTransform="uppercase">
                      {` / ${subPageName}`}
                    </Text.HeadingFourth>
                  </TitleSpan>
                )}
              </TitleSection>
            )}
            {otherButton}
          </StyledHeaderCol>
        </Grid.Row>
      </Grid.Container>
    );
  }
}

PageHeader.propTypes = {
  pageName: PropTypes.string,

  subPageName: PropTypes.string,

  prevButton: PropTypes.shape({
    route: PropTypes.string || PropTypes.bool,
    params: PropTypes.shape({}),
    onClick: PropTypes.func
  }),

  otherButton: PropTypes.node,
  activeLocale: withActiveLocalePropType.isRequired,
  router: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired
};

PageHeader.defaultProps = {
  pageName: 'Page Name',
  subPageName: '',
  prevButton: null,
  otherButton: null
};

const ComposedPageHeader = compose(withActiveLocale, withRouter)(PageHeader);
export default ComposedPageHeader;
